import { useEffect, useState } from 'react';

import logo from '@/assets/lilyLogo.png';
import { formatarEvento } from '@/shared/utils/eventoFormatter';

export const useNextEditionViewModel = () => {
  const [evento, setEvento] = useState(null);
  const [livroMes, setLivroMes] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL}/eventos/proximo`)
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
      .then((data) => {
        if (!data || data.detalhes === null) {
          setEvento(null);
          setLivroMes(null);
          setLoading(false);
          return;
        }

        const eventoBruto = data.detalhes || data;
        const eventoFormatado = formatarEvento(eventoBruto);
        setEvento({ ...eventoFormatado, logoClub: logo });

        // O livro da edição é só o que o admin cadastrou no próprio evento
        // publicado. Antes, quando o evento vinha sem livro, caíamos na
        // Biblioteca procurando um livro do mesmo mês — e aparecia na Home
        // um livro que ninguém tinha posto no evento. A Biblioteca é o
        // acervo, não a fonte da próxima edição.
        setLivroMes(
          eventoBruto.bookTitle
            ? {
                title: eventoBruto.bookTitle,
                author: eventoBruto.bookAuthor || '',
                coverBase64: eventoBruto.bookCoverBase64 || null,
                mesLabel: eventoFormatado.mesNome || '',
              }
            : null,
        );

        setLoading(false);
      })
      .catch(() => {
        setEvento(null);
        setLivroMes(null);
        setLoading(false);
      });
  }, []);

  return { evento, livroMes, loading };
};
